/**
 * src/api/radarCa.js
 * Radar de Compra Ágil, etapa E2 «listas internas». Solo LECTURA: esta pantalla
 * no dispara ni barridos ni recálculos — los cinco POST del router existen y se
 * dejan fuera a propósito (decisión de Manuel, 30-10-2026).
 *
 * Auth por JWT Bearer del usuario admin, como el resto del panel.
 */
import api from './client'

export const getRadarCaTenants = () =>
  api.get('/admin/radar-ca/tenants').then(r => r.data)

// `gris` por defecto a false: la zona gris se GUARDA «para mirarlas, no para
// enseñarlas» (`lista.py`, `tope_gris`), así que no entra en la vista de
// partida. Se pide aparte, y la pantalla la rotula como lo que es.
// El perfil completo del tenant y sus ultimas noches, en UNA peticion: el endpoint
// devuelve las dos cosas juntas. Las pestañas «Perfil» y «Noches» la comparten —
// misma clave en React Query, asi que es una sola llamada aunque se pinten las dos.
export const getRadarCaTenant = (clienteId, { titulos = true, noches = 30 } = {}) =>
  api.get(`/admin/radar-ca/tenants/${clienteId}`, {
    params: { titulos, noches },
  }).then(r => r.data)

/**
 * El Excel de revision a ciegas. NO se puede usar un <a href> directo: el endpoint
 * exige el Bearer y el navegador no lo adjuntaria. Mismo patron que prospeccion.
 *
 * 🔑 Es el unico instrumento de todo el radar que contesta «¿ACIERTA?» en vez de
 * «¿funciono?»: una pestaña por tenant con un desplegable S/N/?, diseñado por el
 * hilo de CA para juzgar la calidad a ciegas. Deberia haber entrado en el paso 1.
 */
export async function descargarRadarCaRevision(dia = null) {
  const r = await api.get('/admin/radar-ca/revision.xlsx', {
    params: dia ? { dia } : {},
    responseType: 'blob',
  })
  const url = URL.createObjectURL(new Blob([r.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  }))
  const a = document.createElement('a')
  a.href = url
  a.download = `revision_radar_ca${dia ? `_${dia}` : ''}.xlsx`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

export const getRadarCaLista = (clienteId, { dia = null, gris = false } = {}) =>
  api.get(`/admin/radar-ca/tenants/${clienteId}/lista`, {
    params: { ...(dia ? { dia } : {}), gris },
  }).then(r => r.data)
